import { render, staticRenderFns } from "./twoStep.vue?vue&type=template&id=ccf87c24&scoped=true"
import script from "./twoStep.vue?vue&type=script&lang=js"
export * from "./twoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf87c24",
  null
  
)

export default component.exports